export default {
    PENDING: 'Pendiente',
    IN_PREPARATION: 'En preparación',
    READY: 'Pedido listo',
    ON_THE_WAY: 'En camino',
    DELIVERED: 'Pedido entregado',
    CLOSED: 'Cerrado',
    CANCELLED: 'Cancelado',
}